/*
const initialstate = {
    products: [
        {
            id: 0,
            name: 'Fake Fruits',
            imageName: 'https://cdn.pixabay.com/photo/2017/06/06/22/46/mediterranean-cuisine-2378758_1280.jpg',
            price: '17.86',
            description: 'Sample fake fruits...'
        }
    ]
} */

const initialstate = {
    products: []
}

const productsReducer = (state = initialstate, action) => {
    switch(action.type){
        case 'ALL_PRODUCTS':
            return {
                ...state,  //append to current redux state
                products: action.payload //input payload to redux state
            }
            default:
                return state;
    }
}
export default productsReducer;